<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="sort-filter-back-modal-button"
        text=""
        (click)="goBack()"
      >
      </ion-back-button>
    </ion-buttons>
    <ion-label data-cy="select-sort-label">
      {{ selectedFilter | titlecase }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-mobile">
  <ng-container *ngIf="selectedFilter === filterTypes.brand">
    <ion-radio-group [(ngModel)]="selectedInputValue" class="radio-options">
      <ion-item *ngFor="let brand of brandsNames">
        <ion-radio justify="space-between" mode="md" [value]="brand">{{
          brand | titlecase
        }}</ion-radio>
      </ion-item>
    </ion-radio-group>
  </ng-container>

  <ng-container *ngIf="selectedFilter === filterTypes.promoType">
    <ion-radio-group [(ngModel)]="selectedInputValue" class="radio-options">
      <ion-item *ngFor="let promoType of promoTypes">
        <ion-radio justify="space-between" mode="md" [value]="promoType">{{
          promoType | titlecase
        }}</ion-radio>
      </ion-item>
    </ion-radio-group>
  </ng-container>

  <ng-container *ngIf="selectedFilter === filterTypes.exclusiveBrand">
    <ion-radio-group [(ngModel)]="selectedInputValue" class="radio-options">
      <ion-item *ngFor="let exclusiveBrand of exclusiveBrandValues">
        <ion-radio justify="space-between" mode="md" [value]="exclusiveBrand">{{
          exclusiveBrand | titlecase
        }}</ion-radio>
      </ion-item>
    </ion-radio-group>
  </ng-container>

  <ng-container *ngIf="selectedFilter === filterTypes.productClass">
    <ion-radio-group [(ngModel)]="selectedInputValue" class="radio-options">
      <ion-item *ngFor="let productClass of productClasses">
        <ion-radio justify="space-between" mode="md" [value]="productClass">{{
          productClass | titlecase
        }}</ion-radio>
      </ion-item>
    </ion-radio-group>
  </ng-container>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="save-modal-btn"
        data-cy="save-filter-list-options-button"
        class="usf-fill-green-mobile-modal-button"
        (click)="returnSelectedValue()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
